import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import usePage from '$app-web/hooks/use-page';
import Logo from '$app-web/modules/auth/components/logo';
import TextLink from '$app-web/modules/auth/components/text-link';
import { URLsManager } from '$app-web/utils';

import Form from './components/form';
import useStyles from './styles';

const PageResetPassword = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    usePage(t('pdash:activity_password_reset_title'));

    return (
        <>
            <Grid item className={classes.iconWrapper}>
                <Logo />
            </Grid>
            <Grid item>
                <Typography variant="body2" color="textPrimary" align="center" gutterBottom>
                    {t('pdash:activity_password_reset_instructions')}
                </Typography>
            </Grid>
            <Grid item className={classes.resetPasswordFormWrapper}>
                <Form />
            </Grid>
            <Grid item>
                <Typography variant="subtitle2" gutterBottom className={classes.linkWrapper}>
                    <TextLink to={URLsManager.to('dashboard:auth:SIGN_IN')}>{t('pdash:login_button_text')}</TextLink>
                </Typography>
            </Grid>
        </>
    );
};

PageResetPassword.propTypes = {};

export default PageResetPassword;
